import VueQR from './vue-qr.vue'
export default VueQR